export const TKeyOffer = {
  OFFER_DUPLICATE_TITLE: "OFFER_DUPLICATE_TITLE",
  OFFER_DUPLICATE_NAME: "OFFER_DUPLICATE_NAME",
  OFFER_REQUIRED_TITLE: "OFFER_REQUIRED_TITLE",
  OFFER_REQUIRED_BADGE: "OFFER_REQUIRED_BADGE",
  OFFER_REQUIRED_TITLE_READER: "OFFER_REQUIRED_TITLE_READER",
  OFFER_REQUIRED_TEXT: "OFFER_REQUIRED_TEXT",
  OFFER_REQUIRED_TEXT_READER: "OFFER_REQUIRED_TEXT_READER",
  OFFER_REQUIRED_CTA: "OFFER_REQUIRED_CTA",
  OFFERS_NAV: "OFFERS_NAV",
  OFFER_NAME_LABEL: "OFFER_NAME_LABEL",
  OFFER_NAME_PLACEHOLDER: "OFFER_NAME_PLACEHOLDER",
  OFFER_TYPE_LABEL: "OFFER_TYPE_LABEL",
  OFFER_TYPE_PLACEHOLDER: "OFFER_TYPE_PLACEHOLDER",
  OFFER_PROBLEM_LABEL: "OFFER_PROBLEM_LABEL",
  OFFER_PROBLEM_PLACEHOLDER: "OFFER_PROBLEM_PLACEHOLDER",
  OFFER_PROMISE_LABEL: "OFFER_PROMISE_LABEL",
  OFFER_PROMISE_PLACEHOLDER: "OFFER_PROMISE_PLACEHOLDER",
  OFFER_KEY_ADVANTAGES_LABEL: "OFFER_KEY_ADVANTAGES_LABEL",
  OFFER_KEY_ADVANTAGES_PLACEHOLDER: "OFFER_KEY_ADVANTAGES_PLACEHOLDER",
  OFFER_KEY_ADVANTAGES_ADD: "OFFER_KEY_ADVANTAGES_ADD",
  OFFER_PROOF_LABEL: "OFFER_PROOF_LABEL",
  OFFER_PROOF_PLACEHOLDER: "OFFER_PROOF_PLACEHOLDER",
  OFFER_PROOF_ADD: "OFFER_PROOF_ADD",
  OFFER_PRICE_LABEL: "OFFER_PRICE_LABEL",
  OFFER_PRICE_PLACEHOLDER: "OFFER_PRICE_PLACEHOLDER",
  OFFER_CREATE_BUTTON: "OFFER_CREATE_BUTTON",
  OFFER_DELETE_TITLE: "OFFER_DELETE_TITLE",
  OFFER_DELETE_WARNING: "OFFER_DELETE_WARNING",
  OFFER_DELETE_CONFIRM: "OFFER_DELETE_CONFIRM",
} as const;
